import React from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
import { COMPANY_INFO, PRICING } from '../data/content';
import Button from './Button';

const Pricing = () => {
  return (
    <section id="cenovnik" className="py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-primary-orange font-bold tracking-wider uppercase mb-3">Cenovnik</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-neutral-darkNavy">Cenovnik Usluga</h3>
          <div className="w-24 h-1 bg-primary-blue mx-auto mt-6 rounded-full" />
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Carpets Pricing */}
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100 h-full"
          >
            <div className="bg-primary-blue p-6 text-center">
              <h4 className="text-2xl font-bold text-white">Tepisi</h4>
            </div>
            <div className="p-8">
              <div className="space-y-6">
                {PRICING.carpets.map((item, index) => (
                  <div key={index} className="flex flex-col sm:flex-row justify-between items-center border-b border-gray-100 pb-4 last:border-0">
                    <span className="text-lg font-medium text-neutral-darkNavy text-center sm:text-left">{item.name}</span>
                    <span className="text-xl font-bold text-primary-orange mt-2 sm:mt-0">{item.price}</span>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>

          {/* Furniture Pricing */}
          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100 h-full"
          >
            <div className="bg-primary-orange p-6 text-center">
              <h4 className="text-2xl font-bold text-white">Dubinsko Pranje Nameštaja</h4>
            </div>
            <div className="p-8">
              <div className="space-y-6">
                {PRICING.furniture.map((item, index) => (
                  <div key={index} className="flex flex-col sm:flex-row justify-between items-center border-b border-gray-100 pb-4 last:border-0">
                    <span className="text-lg font-medium text-neutral-darkNavy text-center sm:text-left">{item.name}</span>
                    <span className="text-xl font-bold text-primary-orange mt-2 sm:mt-0">{item.price}</span>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>

        <div className="text-center mt-12">
          <Button 
            variant="primary" 
            size="lg"
            onClick={() => window.location.href = `tel:${COMPANY_INFO.phone.replace(/\s/g, '')}`}
          >
            <Phone className="w-5 h-5 mr-2" />
            Pozovite za dogovor
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
